"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProviderNameSchema = exports.SearchProviderName = void 0;
exports.isSearchProviderName = isSearchProviderName;
const zod_1 = require("zod");
var SearchProviderName;
(function (SearchProviderName) {
    SearchProviderName["OpenSearch"] = "opensearch";
})(SearchProviderName || (exports.SearchProviderName = SearchProviderName = {}));
exports.SearchProviderNameSchema = zod_1.z.nativeEnum(SearchProviderName);
function isSearchProviderName(name) {
    return Object.values(SearchProviderName).includes(name);
}
//# sourceMappingURL=search-providers.js.map